import type { ReactNode } from 'react';

export const symbol_nest_wake_on_approach: ReactNode = (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960">
		<path
			fill="currentColor"
			d="M794.5-495.5Q780-510 780-531v-259q0-21 14.5-35.5T830-840q21 0 35.5 14.5T880-790v259q0 21-14.5 35.5T830-481q-21 0-35.5-14.5Zm-501-29Q250-568 250-631t43.5-106.5Q337-781 400-781t106.5 43.5Q550-694 550-631t-43.5 106.5Q463-481 400-481t-106.5-43.5ZM80-160v-94q0-35 18-63.5t50-42.5q60-27 123-43.5T400-420q66 0 128.5 17T651-360q32 14 50.5 42.5T720-254v94H80Zm60-60h520v-34q0-17-9-30.5T627-306q-54-26-110.5-40T400-360q-60 0-117 14t-111 40q-15 8-23.5 21.5T140-254v34Zm324-347q26-26 26-64t-26-64q-26-26-64-26t-64 26q-26 26-26 64t26 64q26 26 64 26t64-26Zm-64-64Zm0 411Z"
		/>
	</svg>
);
